import { useState, useEffect } from 'react'
import { arcadeApiClient } from 'apiClients'

interface GameRules {
  name: string
  rules: string
  gameStart: string
  gameEnd: string
  guideRules: string
  thresholdRules: string
  objectiveRequirements?: string
  fundingSource: string
  rewards: Array<string>
  gameType?: string
  isMultiGoal?: boolean
}

export const useGameInfo = (id, userId?: number) => {
  const [data, setData] = useState<GameRules>()
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    if (!id) return

    setIsLoading(true)

    const params = new URLSearchParams()
    if (userId) {
      params.append('user_id', userId.toString())
    }
    const query = params.toString()
    const url = `/multi_platform/games/${id}/rules${query ? `?${query}` : ''}`

    arcadeApiClient
      .get(url)
      .then(res => {
        setData(res.data)
      })
      .catch(err => {
        setError(err)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [id, userId])

  return { data, isLoading, error }
}
